import doctorUsingAI from '../../people/Rectangle 31.png'

function BlogPost({post_img, img_alt_text, heading, author, date_posted, summary}) {
  return (
    <li>
        <div className='paper'>
          <div className='paper-img'>
              <div className="front">
                <img src={post_img} alt={img_alt_text} />
              </div>
              {/* <div className="back">
                <img src={medboltLogo} alt="medbolt logo" />
              </div> */}
          </div>
        </div>
        <h3>{heading}</h3>
        <div>
            <span>{author}</span> - <span>{date_posted}</span>
        </div>
        <p>{summary}</p>
        <button>READ MORE</button>
    </li>
  )
}

BlogPost.defaultProps = {
    post_img: doctorUsingAI,
    img_alt_text: "doctor with a robotic arm using technology"
}

export default BlogPost